var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOtp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-sms",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.219,
    height: 65.393,
    viewBox: "0 0 57.219 65.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-sms-2",
    "data-name": "ic-sms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4237",
    "data-name": "Group 4237",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4236",
    "data-name": "Group 4236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M72.871,12.261V4.087A4.091,4.091,0,0,0,68.783,0h-32.7A4.094,4.094,0,0,0,32,4.087V61.306a4.091,4.091,0,0,0,4.087,4.087h32.7a4.089,4.089,0,0,0,4.087-4.087V49.045H68.783v4.087h-32.7V8.174h32.7v4.087Z",
    transform: "translate(-32 0)",
    fill: "#f16122"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4239",
    "data-name": "Group 4239",
    transform: "translate(24.522 16.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4238",
    "data-name": "Group 4238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M252.609,128H228.087A4.094,4.094,0,0,0,224,132.087v16.348a4.042,4.042,0,0,0,4.087,4.087h4.087v4.087a2.047,2.047,0,0,0,1.128,1.827,2.077,2.077,0,0,0,.916.217,2.047,2.047,0,0,0,1.226-.409l7.631-5.722h9.535a4.042,4.042,0,0,0,4.087-4.087V132.087A4.042,4.042,0,0,0,252.609,128ZM234.3,142.3a2.062,2.062,0,0,1-2.064-2.044,2.024,2.024,0,0,1,2.023-2.044h.041a2.044,2.044,0,0,1,0,4.087Zm12.261,0a2.064,2.064,0,0,1-2.064-2.044,2.027,2.027,0,0,1,2.023-2.044h.041a2.044,2.044,0,0,1,0,4.087Z",
    transform: "translate(-224 -128)",
    fill: "#f16122"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOtp);
export default __webpack_public_path__ + "static/media/ic-otp.cd1756f9.svg";
export { ForwardRef as ReactComponent };